<div class="confirmTable-container">
  <div class="logo-container">
    <img src="assets/img/logo.png" alt="" />
  </div>

  <div class="description-container">
    Veuillez modifier ou valider votre table pour continuer votre demande
  </div>

  <form
    [formGroup]="changeTableForm"
    (ngSubmit)="appelServeur()"
    #formDir="ngForm"
    style="text-align: center"
  >
    <h3>Table nº</h3>
    <input formControlName="idNew" [(ngModel)]="idTable" required />
    <div [class.alert-danger]="idNew.invalid" class="alert ">
      <div  *ngIf="!idNew.invalid">
        Cliquer sur le numéro pour corriger
      </div>
      <div *ngIf="idNew.invalid && idNew.errors.required">
        Un numéro de table doit être renseigné.
      </div>
      <div *ngIf="idNew.invalid && idNew.errors.min">
        Votre numéro ne peut pas être 0 ou inférieur à 0.
      </div>
      <div *ngIf="idNew.invalid && idNew.errors.max">
        Votre numéro ne peut pas être supérieur à 20.
      </div>
    </div>
    
    <div class="button-container">
      <button
        mat-flat-button
        color="primary"
        (click)="openTheTable(idTable)"
        class="okTable"
        [disabled]="changeTableForm.invalid"
      >
        Confirmer ma table
      </button>
    </div>
  </form>
</div>
